// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-1EqL2";
var _4 = "title-1okKW";
var _5 = "text-1bxCb";
var _6 = "footer-1xS9Z";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "title", _5 as "text", _6 as "footer" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "title": _4, "text": _5, "footer": _6 }
